import * as React from 'react';

import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { IconPlusSmall } from '@tock/icons';
import { PlainButton } from 'omakase';
import IconPlusLegacy from 'components/icons/svgr/IconPlus';

interface Props {
  onClick(): void;
  itemText: string;
  isDisabled?: boolean;
}

export const AddButton: React.FunctionComponent<Props> = ({ onClick, itemText, isDisabled }) => {
  return (
    <PlainButton
      variant="primary"
      size="small"
      iconStart={<IconMigrationUtil legacyIcon={<IconPlusLegacy />} newIcon={<IconPlusSmall />} />}
      onClick={onClick}
      disabled={isDisabled}
      aria-label={`Add ${itemText}`}
      className="AddButton"
    >
      Add {itemText}
    </PlainButton>
  );
};
